// Typed static client for the /PriorAuthorization/* endpoints.
// All-static, returns typed data (never a raw AxiosResponse), rethrows errors.
// Follows the PositiveIdService precedent.

import axios from 'axios'
import { Prescription } from '@/models/Prescription'

export class PriorAuthorizationService {
    /** Start a SureScripts electronic prior authorization for the prescription. */
    static async createSurescripts(prescription: Prescription): Promise<unknown> {
        const response = await axios.post('PriorAuthorization/Create/Surescripts', prescription)
        return response.data
    }

    /** Start an expedited SureScripts electronic prior authorization. */
    static async createSurescriptsExpedited(prescription: Prescription): Promise<unknown> {
        const response = await axios.post('PriorAuthorization/Create/Surescripts/Expedited', prescription)
        return response.data
    }
}

export default PriorAuthorizationService
